<template>
<div class="content-i">
    <div class="content-box">
        <div class="element-wrapper compact pt-4">
            <div class="element-actions">
                <a class="btn btn-success btn-sm" href="#"><i class="os-icon os-icon-grid-10"></i>
                    <span>View Statements</span>
                </a>
            </div>
            <h6 class="element-header">Financial Overview</h6>
            <div class="element-box-tp">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="element-balances">
                            <div class="balance hidden-mobile">
                                <div class="balance-title">Total Balance</div>
                                <div class="balance-value"><span>{{ parseFloat(totalBalance).toFixed(2) }}</span></div>
                                <div class="balance-link"><a class="btn btn-link btn-underlined" >
                                    <router-link tag="span" to="/billing/invoice">
                                        View Invoice
                                    </router-link>
                                    <i class="os-icon os-icon-arrow-right4"></i></a></div>
                            </div>
                            <div class="balance">
                                <div class="balance-title">Total Products</div>
                                <div class="balance-value">{{totalProducts}}</div>
                                <div class="balance-link"><a class="btn btn-link btn-underlined" >
                                    <span>View Products</span><i class="os-icon os-icon-arrow-right4"></i>
                                    </a>
                                    </div>
                            </div>
                            <div class="balance">
                                <div class="balance-title">Balance Due</div>
                                <div class="balance-value danger">0.00</div>
                                <div class="balance-link"><a class="btn btn-link btn-underlined btn-gold" ><span>Pay Now</span><i class="os-icon os-icon-arrow-right4"></i></a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="element-wrapper">
            <h6 class="element-header">Balance Breakdown</h6>
            <div class="element-box-tp">
                <div class="table-responsive">
                    <table class="table table-padded">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Statement Date</th>
                                <th>Description</th>
                                <th class="text-center">Type</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tier in balance">
                                <td class="nowrap"><span class="status-pill smaller yellow"></span><span>Not Posted</span></td>
                                <td>{{tier.tier}} Usage</td>
                                <td class="cell-with-media">
                                    {{tier.utilized}} Products
                                </td>
                                <td class="text-center"><a class="badge badge-success" href="">Per Product</a></td>
                                <td class="text-right bolder nowrap"><span class="text-success">+ {{ parseFloat(tier.cost).toFixed(2) }} AED</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>

export default {
  data () {
    return {
      client: '',
      balance: ''
    }
  },
  mounted () {
    this.getDashboard()
  },
  methods: {
    getDashboard: function () {
      var self = this
      const url = '/billing/dashboard'
      self.$store.dispatch('updateLoading', 'true')
      this.$http.post(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          console.log(response)
          self.client = response.data.client
          self.balance = response.data.balance
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    },
    totalAmount: function (balance) {
      return num * document.getElementById('multiplyWith').value
    }
  },
  computed: {
    totalBalance () {
      var self = this
      if (self.balance == '') return 0
      let sum = 0
      for (var j = 0; j < self.balance.length; j++) {
        sum += self.balance[j].cost
      }
      return sum
    },
    totalProducts () {
      var self = this
      if (self.balance == '') return 0
      let sum = 0
      for (var j = 0; j < self.balance.length; j++) {
        sum += self.balance[j].utilized
      }
      return sum
    }
  }

}

</script>
